import * as SliderPrimitive from '@radix-ui/react-slider'
import { styled } from '../../../lib/stitches'
import { gray15 } from '../../platform/color'

const StyledSlider = styled(SliderPrimitive.Root, {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  userSelect: 'none',
  touchAction: 'none',
  height: '12px',
  '&:hover span': {
    opacity: 1
  }
})

const StyledSliderTrack = styled(SliderPrimitive.Track, {
  height: '4px',
  borderRadius: '9999px',
  flexGrow: 1,
  background: 'rgba(0,0,0,.05)'
})

const StyledSliderRange = styled(SliderPrimitive.Range, {
  position: 'absolute',
  height: '4px',
  background: gray15,
  borderRadius: '9999px'
})

const StyledSliderThumb = styled(SliderPrimitive.Thumb, {
  all: 'unset',
  display: 'block',
  width: '4px',
  height: '10px',
  opacity: 0,
  border: '2px solid white',
  boxSizing: 'content-box',
  transition: 'opacity 100ms ease',
  background: gray15,
  borderRadius: 10,
  '&:hover': { opacity: 1 }
})

export const Root = StyledSlider
export const Track = StyledSliderTrack
export const Range = StyledSliderRange
export const Thumb = StyledSliderThumb
